import styled from 'styled-components';

export const StyledPageFilter = styled.div`
  width: 100%;
`;
